<mat-icon fontSet="fa" [fontIcon]="name" class="fa-lg" [ngClass]="'fa-' + name"></mat-icon>